/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { NavigationItem } from './types';

export const defaultHeaderData: NavigationItem[] = [
  {
    id: 'download_app',
    label: 'App',
    redirectUrl: 'https://www.airasia.com/aa/appdownload/',
    type: 'app_link',
    imageUrl:
      'https://static.airasia.com/mobile/phoenix/icons/v1/main/svg/file/file_download.svg',
  },
  {
    id: 'purchases',
    label: 'Purchases',
    redirectUrl: 'https://www.airasia.com/purchases/',
    type: 'text_link',
  },
  {
    id: 'checkin',
    label: 'Check-in',
    redirectUrl: 'https://www.airasia.com/check-in/en/gb',
    type: 'text_link',
  },
  {
    id: 'faq',
    label: 'FAQ',
    redirectUrl: 'https://www.airasia.com/search/en-gb',
    type: 'text_link',
  },
  {
    id: 'flightstatus',
    label: 'Flight status',
    redirectUrl: 'https://www.airasia.com/flightstatus/en/GB',
    type: 'text_link',
  },
  {
    id: 'support',
    label: 'Support',
    redirectUrl: 'https://support.airasia.com/s/?language=en_GB',
    type: 'text_link',
  },
  {
    id: 'promotions',
    label: 'Promotions',
    redirectUrl: 'https://www.airasia.com/promotions/',
    type: 'text_link',
  },
];
